import React, { createContext } from 'react';




type WsAppContextProps = {
  theme: string | undefined,
  setTheme: React.Dispatch<React.SetStateAction<string>>,

  role: string | undefined,
  setRole: React.Dispatch<React.SetStateAction<string>>
};




const WsAppContext = createContext<WsAppContextProps | undefined>(undefined);




export {
  WsAppContext
};
